module.exports = __webpack_public_path__ + "img/text2_zhTc@3x.12e9a689.png";